import { Component, type ReactNode } from "react";
import { isAssetLoadError, reloadForAssetFailure } from "@/lib/asset-recovery";

export default class PageLoadBoundary extends Component<
  { children: ReactNode },
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error) {
    // Recover asset errors only. Rendering/programming errors still show the
    // explicit fallback instead of repeatedly refreshing a broken page.
    if (isAssetLoadError(error)) reloadForAssetFailure();
  }

  render() {
    if (this.state.failed) {
      return (
        <div role="alert">
          <p>This page could not finish loading. Please refresh to try again.</p>
          <button type="button" onClick={() => window.location.reload()}>Refresh page</button>
        </div>
      );
    }
    return this.props.children;
  }
}
